var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddproposal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C11.4477 2 11 2.44772 11 3V9C11 9.55228 11.4477 10 12 10C12.5523 10 13 9.55228 13 9V3C13 2.44772 12.5523 2 12 2Z",
    fill: "#4CAF50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 6C3 4.34315 4.34315 3 6 3H18C19.6569 3 21 4.34315 21 6V18C21 19.6569 19.6569 21 18 21H6C4.34315 21 3 19.6569 3 18V6Z",
    fill: "#2196F3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 12H7V14H17V12Z",
    fill: "#FFC107"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 17H9V19H15V17Z",
    fill: "#FFC107"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7071 4.70711C21.0786 4.31658 21.0786 3.68342 20.7071 3.29289L19.2929 1.87868C18.9024 1.48817 18.2692 1.48817 17.8787 1.87868C17.4882 2.2692 17.4882 2.90237 17.8787 3.29289L19.2929 4.70711C19.6834 5.09763 20.3166 5.09763 20.7071 4.70711Z",
    fill: "#F44336"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddproposal);
export default __webpack_public_path__ + "static/media/addproposal.29cb19ed098d75a5796db899c468506d.svg";
export { ForwardRef as ReactComponent };